<template>
    <div v-loading="dataLoading">
        <el-card header="汇总统计">
            <el-row v-if="$utils.have('/compare/dashboard/list')" :gutter="20">
                <el-col :xs="24" :sm="14">
                    <div id="chartContainer1" ref="chartContainer1"></div>
                </el-col>
                <el-col :xs="24" :sm="10">

                    <!-- <el-card header="双方共有演出占比">
                        <div id="chartContainer2" ref="chartContainer2"></div>
                    </el-card> -->
                    <div class="list-box">
                        <div class="list-group">
                            <el-card>
                                <div slot="header">
                                    <div class="logo-box">
                                        <img class="logo" src="@/assets/img/dashboard/d-logo1.png" />秀动
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="list">
                                        演出总数：{{ xdData2 }}
                                    </div>
                                    <div class="list">
                                        秀动独有：{{ xdData1 }}
                                    </div>
                                </div>
                            </el-card>
                            <el-card>
                                <div slot="header">
                                    <div class="logo-box">
                                        <img class="logo" src="@/assets/img/dashboard/d-logo6.png" />大麦
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="list">
                                        演出总数：{{ dmData2 }}
                                    </div>
                                    <div class="list">
                                        大麦独有：{{ dmData1 }}
                                    </div>
                                </div>
                            </el-card>
                            <el-card>
                                <div slot="header">
                                    <div class="logo-box">
                                        <img class="logo" src="@/assets/img/dashboard/d-logo1.png" />
                                        <img class="logo" src="@/assets/img/dashboard/d-logo6.png" />
                                        秀动&大麦(共有)
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="list">
                                        共有总数：{{ gyData3 }}
                                    </div>
                                    <div class="list">
                                        秀动推送大麦：{{ gyData1 }}
                                    </div>
                                    <div class="list">
                                        大麦自行上架：{{ gyData2 }}
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div v-else>暂无查看权限，请联系管理员</div>
        </el-card>
    </div>
</template>

<script>
import { Venn, Pie } from '@antv/g2plot';

export default {
    data() {
        return {
            dataLoading: false,

            xdData1: "", //秀动独有
            xdData2: "", //秀动总数

            dmData1: "", //大麦独有
            dmData2: "", //大麦总数

            gyData1: "", //秀动推送大麦
            gyData2: "", //大麦自行上架
            gyData3: "" //共有总数

        }
    },
    mounted() {
        if (this.$utils.have('/compare/dashboard/list')) {
            this.getData();
        }

    },
    methods: {
        //获取数据
        getData() {
            this.dataLoading = true;
            this.$request({
                url: "/compare/dashboard/list",
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result && result.length > 0) {

                        this.xdData1 = result.find(v => v.type == 1)?.cnt || 0
                        this.dmData1 = result.find(v => v.type == 2)?.cnt || 0
                        this.gyData1 = result.find(v => v.type == 3)?.cnt || 0
                        this.gyData2 = result.find(v => v.type == 4)?.cnt || 0

                        this.gyData3 = this.$utils.numPlus(this.gyData1, this.gyData2)
                        this.xdData2 = this.$utils.numPlus(this.xdData1, this.gyData3)
                        this.dmData2 = this.$utils.numPlus(this.dmData1, this.gyData3)

                        this.drawChart1();
                        // this.drawChart2();
                    } else {
                        this.$message.error(msg || "获取数据失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取数据失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        drawChart1() {
            if (this.plot1) this.plot1.destroy();
            const data = [
                { sets: ['秀动'], size: this.xdData2, label: '秀动独有', title: '秀动', num: this.xdData1, tooltipList: ['总数：' + this.xdData2, '独有：' + this.xdData1] },
                { sets: ['大麦'], size: this.dmData2, label: '大麦独有', title: '大麦', num: this.dmData1, tooltipList: ['总数：' + this.dmData2, '独有：' + this.dmData1] },
                { sets: ['共有'], size: this.gyData3, bgcolor: 'transparent' },
                { sets: ['秀动', '大麦'], size: this.gyData3, label: this.gyData1 > this.gyData2 ? '秀动推送大麦' : '大麦自行上架', num: this.gyData1 > this.gyData2 ? this.gyData1 : this.gyData2, title: '共有', tooltipList: ['总数：' + this.gyData3, '秀动推送大麦：' + this.gyData1, '大麦自行上架：' + this.gyData2] },
                { sets: ['秀动', '共有'], size: this.gyData1, bgcolor: 'transparent' },
                { sets: ['大麦', '共有'], size: this.gyData2, bgcolor: 'transparent' },
                { sets: ['秀动', '大麦', '共有'], size: this.gyData1 > this.gyData2 ? this.gyData2 : this.gyData1, label: this.gyData1 > this.gyData2 ? '大麦自行上架' : '秀动推送大麦', num: this.gyData1 > this.gyData2 ? this.gyData2 : this.gyData1, title: '共有', tooltipList: ['总数：' + this.gyData3, '秀动推送大麦：' + this.gyData1, '大麦自行上架：' + this.gyData2], },
            ];
            this.plot1 = new Venn('chartContainer1', {
                data: data,
                setsField: 'sets',
                sizeField: 'size',
                blendMode: 'overlay',
                pointStyle: { fillOpacity: 0.8 },
                height: 540,
                legend: false,
                color: (datum, defaultColor) => {
                    return datum.bgcolor || defaultColor;
                },
                label: {
                    style: {
                        fontSize: 10,
                        fill: '#333'
                    },
                    formatter: (datum) => datum.label ? (datum.num ? `${datum.label}\n${datum.num}` : `${datum.label}\n${datum.size}`) : ""
                },
                tooltip: {
                    // fields: ['sets', 'size'],
                    customContent: (title, items) => {
                        const datum = items[0]?.data || {};
                        let listStr = '';
                        if (datum.tooltipList && datum.tooltipList.length > 0) {
                            datum.tooltipList.map(v => {
                                listStr += `<div class="g2-tooltip-list-item">${v}</div>`;
                            })
                        }
                        return listStr ? `<div>
                            <div class="g2-tooltip-title" style="font-size:13px;font-weight:700;">${datum.title}</div>
                            <div class="g2-tooltip-list">${listStr}</div>
                        </div>` : false
                    }
                }
            })
            this.plot1.render();
        },
        drawChart2() {
            if (this.pie1) this.pie1.destroy();
            const data = [
                { type: '秀动推送大麦', value: this.gyData1 },
                { type: '大麦自行上架', value: this.gyData2 },
            ];
            this.pie1 = new Pie('chartContainer2', {
                appendPadding: 0,
                data,
                angleField: 'value',
                colorField: 'type',
                radius: 0.6,
                legend: false,
                label: {
                    type: 'outer',
                    labelHeight: 28,
                    content: '{name}\n演出数：{value}\n占比：{percentage}',
                    interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
                },
            })
            this.pie1.render();
        }
    }
}
</script>
<style lang="scss" scoped>
.list-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .list-group {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .el-card{
            margin: 5px 0;
        }
        .logo-box {
            display: flex;
            align-items: center;
            .logo {
                width: 24px;
                height: 24px;
                margin-right: 10px;
                background: #000;
                border-radius: 4px;
                overflow: hidden;
            }
        }


        .info {
            .list {
                margin: 5px 0;
                font-size: 12px;
            }
        }

    }
}
</style>